import {
  AlertDialog, AlertDialogContent, AlertDialogHeader,
  AlertDialogTitle, AlertDialogDescription, AlertDialogFooter,
  AlertDialogAction, AlertDialogCancel,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'

function fmtHMS(s: number): string {
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
}

interface IdleAlertProps {
  open: boolean
  seconds: number
  onContinue: () => void
  onPause: () => void
  onStop: () => void
}

export default function IdleAlert({ open, seconds, onContinue, onPause, onStop }: IdleAlertProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2.5 mb-1">
            <span className="material-symbols-outlined text-[20px] text-[#555]">schedule</span>
            <AlertDialogTitle>Sem atividade detectada</AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            Não detectamos atividade nos últimos 15 minutos.
            O timer está em <span className="text-[#f0f0f0] font-medium [font-variant-numeric:tabular-nums]">{fmtHMS(seconds)}</span>.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel asChild>
            <Button variant="destructive" className="rounded-full" onClick={onStop}>
              Encerrar sessão
            </Button>
          </AlertDialogCancel>
          <AlertDialogCancel asChild>
            <Button variant="secondary" className="rounded-full" onClick={onPause}>
              Pausar sessão
            </Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button className="rounded-full" onClick={onContinue}>
              Continuar trabalhando
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
